module.exports = __webpack_public_path__ + "static/media/ic_why_loan_4.3ddde45a.svg";